import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import React from "react";
import Purchase from "../purchase/purchase";
import Stocks from "../stocks/stocks";
import ItemServices from "../items_services/ItemServices";
import ItemCategories from "../ItemsCategories/itemCategories";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
export const ItemService = () => {
  const [value, setValue] = React.useState("all");
  const handleChange = (event, newValue) => {
    // setPageNo(1);
    setValue(newValue);
  };
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );
  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={2}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            background:
              "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            padding: "10px",
            mt: "10px",
            borderRadius: "5px",
            color: "#01008B",
            textAlign: "left",
            marginBottom: "10px",
            fontFamily: "'Montserrat', sans-serif",
             fontSize: { xs: "12px", sm: "13px", md: "15px" },

            fontWeight: 500,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "12px", sm: "15px" },
            }}
          >
            {businessChooseTab?.value === "itemcategory"
              ? "Service Category"
              : "Service/Product Details"}
          </Typography>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            {(!businessChooseTab ||
              businessChooseTab?.value == "itemDetail") && (
              <ItemServices config={{ addBtn: true, message: false }} />
            )}
            {businessChooseTab?.value == "itemcategory" && <ItemCategories />}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
